import { Chip } from '@mui/material';
import React, { FC } from 'react';
import { useStyles } from './PlayoffGameChip.styles';

export const PlayoffGameChip: FC = () => {
  const { classes } = useStyles();

  return <Chip className={classes.root} label="Playoff" />;
};
